// 环保管家目录
<template>
  <div class="ehs-menu-page">
    <div class="menu-list">
      <div class="m-l-tab" v-for="(item) in menuList" :key="item.id">
        <div class="m-l-tab-label tab-hover" :class="{'tab-clicked': menuTabId === item.id}" @click="menuTabClicked(item.id)">{{ item.content }}</div>
        <div class="m-l-SubTab" v-for="(subItem) in item.children" :key="subItem.id">
          <div class="m-l-SubTab-label tab-hover" :class="{'tab-clicked': menuSubTabId === subItem.id}" v-if="menuTabId === item.id" @click="menuSubTabClicked(subItem)">{{ subItem.content }}</div>
        </div>
      </div>
    </div>
    <div class="main">
      <iframe :src="iframeSrc" height="100%" width="100%" scrolling="no" frameborder="0"></iframe>
    </div>
    <nut-dialog
      @close="showYearDialog = true"
      v-if="showYearDialog"
      :visible="showYearDialog"
      title="基础设定"
      :noFooter="true">
      <div>
        <select name="unitName" v-model="unitName">
          <option v-for="(subItem, index) in optionsNew" :key="index" :value="subItem.value">{{ subItem.label }}</option>
        </select>
      </div>
      <p>温馨提示：</p>
      <p>（1）被选择的单位将成为<b style="color: black;">环保管家</b>中所使用的<b style="color: black;">默认单位名称</b>，如排污许可执行报告、信息公开表公示等。</p>
      <p>（2）<b style="color: black;">选择或新增</b>一个单位有利于其信息同步，如选择A单位并填写完其<b style="color: black;">单位基本信息</b>后，在其他页面中<b style="color: black;">再次选择A单位</b>即可同步已填写的信息，<b style="color: black;">无需重复填写</b>。</p>
      <el-button type="primary" @click="submitUnit" size="medium">确定</el-button>
      <!-- <el-form ref="unitInfo" :model="unitInfo">
        <el-form-item label="选择查看的单位">
          <el-select v-model="unitInfo.unitName" filterable allow-create default-first-option placeholder="可新增选项里没有的单位">
            <el-option
              v-for="item in optionsNew"
              :key="item.index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="选择查看的地区">
          <el-select v-model="mapProvinceActive" placeholder="请选择">
            <el-option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据更新的时间">
          <el-select v-model="autoRefreshRTISetting" placeholder="请选择">
            <el-option label="5分钟" value="5"></el-option>
            <el-option label="10分钟" value="10"></el-option>
            <el-option label="15分钟" value="15"></el-option>
            <el-option label="20分钟" value="20"></el-option>
            <el-option label="30分钟" value="30"></el-option>
            <el-option label="1小时" value="60"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <p>温馨提示：</p>
        <p>（1）被选择的单位将成为<b style="color: black;">环保管家</b>中所使用的<b style="color: black;">默认单位名称</b>，如排污许可执行报告、信息公开表公示等。</p>
        <p>（2）<b style="color: black;">选择或新增</b>一个单位有利于其信息同步，如选择A单位并填写完其<b style="color: black;">单位基本信息</b>后，在其他页面中<b style="color: black;">再次选择A单位</b>即可同步已填写的信息，<b style="color: black;">无需重复填写</b>。</p> -->
        <!-- <p>（3）被选择的地区将成为<b style="color: black;">地图功能</b>的<b style="color: black;">默认初始加载地区</b>。</p> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="submitUnit" size="medium">确定</el-button>
        </el-form-item> -->
      <!-- </el-form> -->
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../../api/index'
export default {
  data () {
    return {
      showYearDialog: true,
      unitInfo: {},
      optionsNew: [],
      mapProvinceActive: '',
      menuTabId: 0,
      menuSubTabId: 0,
      iframeSrc: '/h5EHS-ehsHome',
      menuList: [
        {
          id: 1,
          index: '',
          content: '区域概况',
          showFlag: 1,
          children: [
            {
            //   id: 2,
            //   index: '/ehsEnQltyMnt',
            //   content: '环境质量监控',
            //   showFlag: 1
            // }, {
              id: 3,
              index: '/h5EHS-ehsHome',
              content: '区域排放监控',
              showFlag: 1
            }
          ]
        }, {
          id: 204,
          index: '',
          content: '管理体系',
          showFlag: 1,
          children: [
            {
              id: 205,
              index: '/ehsManagement',
              content: '管理体系详情',
              showFlag: 1
            // }, {
            //   id: 206,
            //   index: '/ehsJobRes',
            //   content: '岗位职责',
            //   showFlag: 1
            // }, {
            //   id: 207,
            //   index: '/ehsPlanYear',
            //   content: '工作年度计划',
            //   showFlag: 1
            // }, {
            //   id: 208,
            //   index: '/ehsManSystem',
            //   content: '管理制度',
            //   showFlag: 1
            }
          ]
        }, {
          id: 209,
          index: '',
          content: '调查类项目',
          showFlag: 1,
          children: [
            {
              id: 210,
              index: '/ehsInvestigation',
              content: '调查类项目详情',
              showFlag: 1
            // }, {
            //   id: 211,
            //   index: '/ehsRecEffect',
            //   content: '恢复效果调查',
            //   showFlag: 1
            // }, {
            //   id: 212,
            //   index: '/ehsBuild',
            //   content: '建设用地土壤污染调查',
            //   showFlag: 1
            // }, {
            //   id: 213,
            //   index: '/ehsInvOther',
            //   content: '其他',
            //   showFlag: 1
            }
          ]
        }, {
          id: 214,
          index: '',
          content: '水土保持方案',
          showFlag: 1,
          children: [
            {
              id: 215,
              index: '/ehsSoilWater',
              content: '水土保持方案详情',
              showFlag: 1
            // }, {
            //   id: 216,
            //   index: '/ehsSinWellSoilWater',
            //   content: '单井水土保持方案',
            //   showFlag: 1
            // }, {
            //   id: 217,
            //   index: '/ehsOtherSoilWater',
            //   content: '其他项目水土保持方案',
            //   showFlag: 1
            }
          ]
        }, {
          id: 4,
          index: '',
          content: '企业概况',
          showFlag: 1,
          children: [
            {
              id: 5,
              index: '/ehsProfile',
              content: '企业概况详情',
              showFlag: 1
            // }, {
            //   id: 6,
            //   index: '/ehsMain',
            //   content: '主体工程',
            //   showFlag: 1
            // }, {
            //   id: 7,
            //   index: '/ehsMaterial',
            //   content: '原辅材料',
            //   showFlag: 1
            // }, {
            //   id: 8,
            //   index: '/ehsEnvir',
            //   content: '环保工程',
            //   showFlag: 1
            }
          ]
        }, {
          id: 9,
          index: '',
          content: '环评管理',
          showFlag: 1,
          children: [
            {
              id: 1401,
              index: '/ehsEia',
              content: '环评管理详情',
              showFlag: 1
            // }, {
            //   id: 1402,
            //   index: '/ehsSingleWell',
            //   content: '单井环评',
            //   showFlag: 1
            // }, {
            //   id: 1403,
            //   index: '/ehsOther',
            //   content: '其他项目环评及验收',
            //   showFlag: 1
            // }, {
            //   id: 10,
            //   index: '/ehsEiaStart',
            //   content: '委托启动',
            //   showFlag: 1
            // }, {
            //   id: 11,
            //   index: '/ehsEiaProg',
            //   content: '工作进度',
            //   showFlag: 1
            // }, {
            //   id: 12,
            //   index: '/ehsEiaDocu',
            //   content: '资料整理',
            //   showFlag: 1
            // }, {
            //   id: 13,
            //   index: '/ehsEiaAnno',
            //   content: '环评公示',
            //   showFlag: 1
            // }, {
            //   id: 14,
            //   index: '/ehsEiaAppr',
            //   content: '环评评审',
            //   showFlag: 1
            // }, {
            //   id: 15,
            //   index: '/ehsEiaSubmit',
            //   content: '环评报批',
            //   showFlag: 1
            // }, {
            //   id: 16,
            //   index: '/ehsEiaFile',
            //   content: '环评存档',
            //   showFlag: 1
            }
          ]
        }, {
          id: 17,
          index: '',
          content: '场调管理',
          showFlag: 1,
          children: [
            {
              id: 18,
              index: '/ehsFieldTone',
              content: '场调管理详情',
              showFlag: 1
            // }, {
            //   id: 19,
            //   index: '/ehsFildProg',
            //   content: '工作进度',
            //   showFlag: 1
            // }, {
            //   id: 20,
            //   index: '/ehsFildDocu',
            //   content: '资料整理',
            //   showFlag: 1
            // }, {
            //   id: 21,
            //   index: '/ehsFildAnno',
            //   content: '场调公示',
            //   showFlag: 1
            // }, {
            //   id: 22,
            //   index: '/ehsFildAppr',
            //   content: '场调评审',
            //   showFlag: 1
            // }, {
            //   id: 23,
            //   index: '/ehsFildSubmit',
            //   content: '场调报备',
            //   showFlag: 1
            // }, {
            //   id: 24,
            //   index: '/ehsFildFile',
            //   content: '场调存档',
            //   showFlag: 1
            }
          ]
        }, {
          id: 25,
          index: '',
          content: '环境监理',
          showFlag: 1,
          children: [
            {
              id: 26,
              index: '/ehsEnvSup',
              content: '环境监理详情',
              showFlag: 1
            // }, {
            //   id: 27,
            //   index: '/ehsSupProg',
            //   content: '工作进度',
            //   showFlag: 1
            // }, {
            //   id: 28,
            //   index: '/ehsSupDocu',
            //   content: '资料整理',
            //   showFlag: 1
            // }, {
            //   id: 29,
            //   index: '/ehsSupAppr',
            //   content: '监理评审',
            //   showFlag: 1
            // }, {
            //   id: 30,
            //   index: '/ehsSupSubmit',
            //   content: '监理报备',
            //   showFlag: 1
            // }, {
            //   id: 31,
            //   index: '/ehsSupFile',
            //   content: '监理存档',
            //   showFlag: 1
            }
          ]
        }, {
          id: 32,
          index: '',
          content: '应急预案',
          showFlag: 1,
          children: [
            {
              id: 33,
              index: '/ehsEmePlan',
              content: '应急预案详情',
              showFlag: 1
            // }, {
            //   id: 34,
            //   index: '/ehsPlanProg',
            //   content: '工作进度',
            //   showFlag: 1
            // }, {
            //   id: 35,
            //   index: '/ehsPlanDocu',
            //   content: '资料整理',
            //   showFlag: 1
            // }, {
            //   id: 36,
            //   index: '/ehsPlanAnno',
            //   content: '预案公示',
            //   showFlag: 1
            // }, {
            //   id: 37,
            //   index: '/ehsPlanAppr',
            //   content: '预案评审',
            //   showFlag: 1
            // }, {
            //   id: 38,
            //   index: '/ehsPlanSubmit',
            //   content: '预案报备',
            //   showFlag: 1
            // }, {
            //   id: 39,
            //   index: '/ehsPlanFile',
            //   content: '预案存档',
            //   showFlag: 1
            }
          ]
        }, {
          id: 40,
          index: '',
          content: '排污许可',
          showFlag: 1,
          children: [
            {
              id: 41,
              index: '/ehsBloPermit',
              content: '排污许可详情',
              showFlag: 1
            // }, {
            //   id: 42,
            //   index: '/ehsBloProg',
            //   content: '工作进度',
            //   showFlag: 1
            // }, {
            //   id: 43,
            //   index: '/ehsBloDocu',
            //   content: '资料整理',
            //   showFlag: 1
            // }, {
            //   id: 44,
            //   index: '/ehsDisSpec',
            //   content: '排放口规范',
            //   showFlag: 1
            // }, {
            //   id: 440,
            //   index: '/ehsPolSource',
            //   content: '污染源管理',
            //   showFlag: 1
            // }, {
            //   id: 45,
            //   index: '/ehsGasEng',
            //   content: '废气处理工程建设',
            //   showFlag: 1
            // }, {
            //   id: 46,
            //   index: '/ehsWaterEng',
            //   content: '废水处理工程建设',
            //   showFlag: 1
            // }, {
            //   id: 47,
            //   index: '/ehsSolidEng',
            //   content: '固废工程建设',
            //   showFlag: 1
            // }, {
            //   id: 48,
            //   index: '/ehsOtherEng',
            //   content: '其他环保工程建设',
            //   showFlag: 1
            // }, {
            //   id: 49,
            //   index: '/ehsReport',
            //   content: '执行报告',
            //   showFlag: 1
            // }, {
            //   id: 888,
            //   index: '/ehsPublicity',
            //   content: '信息公开表公示信息',
            //   showFlag: 1
            }
          ]
        }, {
          id: 1001,
          index: '',
          content: '信息披露',
          showFlag: 1,
          children: [
            {
              id: 1002,
              index: '/ehsAnnualReport',
              content: '年度报告',
              showFlag: 1
            }
          ]
        }, {
          id: 50,
          index: '',
          content: '工程设计',
          showFlag: 1,
          children: [
            {
              id: 51,
              index: '/ehsDesign',
              content: '工程设计详情',
              showFlag: 1
            // }, {
            //   id: 52,
            //   index: '/ehsDesignProg',
            //   content: '工作进度',
            //   showFlag: 1
            // }, {
            //   id: 53,
            //   index: '/ehsDesignDocu',
            //   content: '资料整理',
            //   showFlag: 1
            // }, {
            //   id: 54,
            //   index: '/ehsDesignAppr',
            //   content: '设计评审',
            //   showFlag: 1
            // }, {
            //   id: 55,
            //   index: '/ehsDesignSubmit',
            //   content: '设计定稿',
            //   showFlag: 1
            // }, {
            //   id: 56,
            //   index: '/ehsDesignFile',
            //   content: '存档备查',
            //   showFlag: 1
            }
          ]
        }, {
          id: 57,
          index: '',
          content: '环保验收',
          showFlag: 1,
          children: [
            {
              id: 58,
              index: '/ehsCheck',
              content: '环保验收详情',
              showFlag: 1
            // }, {
            //   id: 59,
            //   index: '/ehsCheckProg',
            //   content: '工作进度',
            //   showFlag: 1
            // }, {
            //   id: 60,
            //   index: '/ehsCheckDocu',
            //   content: '资料整理',
            //   showFlag: 1
            // }, {
            //   id: 61,
            //   index: '/ehsCheckAnno',
            //   content: '验收公示',
            //   showFlag: 1
            // }, {
            //   id: 62,
            //   index: '/ehsCheckAppr',
            //   content: '验收评审',
            //   showFlag: 1
            // }, {
            //   id: 63,
            //   index: '/ehsCheckSubmit',
            //   content: '验收报备',
            //   showFlag: 1
            // }, {
            //   id: 64,
            //   index: '/ehsCheckFile',
            //   content: '存档备查',
            //   showFlag: 1
            }
          ]
        // }, {
        //   id: 65,
        //   index: '',
        //   content: '环保设备',
        //   showFlag: 1,
        //   children: [
        //     {
        //       id: 66,
        //       index: '/ehsEquipTypeAdmin',
        //       content: '设备类型维护',
        //       showFlag: 1
        //     }, {
        //       id: 67,
        //       index: '/ehsEquipInfoAdmin',
        //       content: '设备基础信息管理',
        //       showFlag: 1
        //     }, {
        //       id: 68,
        //       index: '/ehsEquipInfoCheck',
        //       content: '设备基础信息审核',
        //       showFlag: 1
        //     }
        //   ]
        // }, {
        //   id: 69,
        //   index: '',
        //   content: '环保耗材',
        //   showFlag: 1,
        //   children: [
        //     {
        //       id: 70,
        //       index: '/ehsMatTypeAdmin',
        //       content: '耗材类型维护',
        //       showFlag: 1
        //     }, {
        //       id: 71,
        //       index: '/ehsMatAppendAdmin',
        //       content: '耗材新增管理',
        //       showFlag: 1
        //     }, {
        //       id: 72,
        //       index: '/ehsReqMatTake',
        //       content: '耗材领用申请',
        //       showFlag: 1
        //     }, {
        //       id: 73,
        //       index: '/ehsCheckMatTake',
        //       content: '耗材领用审核',
        //       showFlag: 1
        //     }, {
        //       id: 74,
        //       index: '/ehsRecycleWaste',
        //       content: '废弃物回收',
        //       showFlag: 1
        //     }
        //   ]
        }, {
          id: 75,
          index: '',
          content: '环保台账',
          showFlag: 1,
          children: [
            {
              id: 76,
              index: '/ehsGasBook',
              content: '废气台账',
              showFlag: 1
            }, {
              id: 77,
              index: '/ehsWaterBook',
              content: '废水台账',
              showFlag: 1
            }, {
              id: 78,
              index: '/ehsFixedBook',
              content: '固废台账',
              showFlag: 1
            // }, {
            //   id: 1004,
            //   index: '',
            //   content: '在线监测',
            //   showFlag: 1,
            //   children: [{
            //     id: 1005,
            //     index: '/ehsOLMntAtmos',
            //     content: '废气在线监测',
            //     showFlag: 1
            //   }, {
            //     id: 1006,
            //     index: '/ehsOLMntWater',
            //     content: '废水在线监测',
            //     showFlag: 1
            //   }, {
            //     id: 1007,
            //     index: '/ehsOLMntUelectro',
            //     content: '用电在线监测',
            //     showFlag: 1
            //   }, {
            //     id: 1008,
            //     index: '/ehsOLMntUwater',
            //     content: '用水在线监测',
            //     showFlag: 1
            }
          ]
        }, {
          id: 79,
          index: '',
          content: '自行监测',
          showFlag: 1,
          children: [
            {
              id: 1303,
              index: '/ehsMonitorPlan',
              content: '年度环境监测计划',
              showFlag: 1
            }, {
              id: 80,
              index: '/ehsGasMonitor',
              content: '废气自行监测',
              showFlag: 1
            }, {
              id: 81,
              index: '/ehsWaterMonitor',
              content: '废水自行监测',
              showFlag: 1
            }, {
              id: 1306,
              index: '/ehsNoiseMonResult',
              content: '噪声环境监测结果',
              showFlag: 1
            }, {
              id: 82,
              index: '/ehsFixedMonitor',
              content: '固废自行监测',
              showFlag: 1
            }, {
              id: 1307,
              index: '/ehsQuaMonResult',
              content: '环境质量监测结果',
              showFlag: 1
            }, {
              id: 1308,
              index: '/ehsLDARTest',
              content: 'LDAR检测',
              showFlag: 1
            }
          ]
        }, {
          id: 1600,
          index: '',
          content: '固体废物管理',
          showFlag: 1,
          children: [
            {
              id: 1601,
              index: '/ehsHazWaste',
              content: '危险废物',
              showFlag: 1
            // }, {
            //   id: 1603,
            //   index: '/ehsHazWasMan',
            //   content: '危险废物处置',
            //   showFlag: 1
            }, {
              id: 1602,
              index: '/ehsHazWasLabel',
              content: '危废标签标志',
              showFlag: 1
            }, {
              id: 1604,
              index: '/ehsHazWasSave',
              content: '危险废物暂存',
              showFlag: 1
            }, {
              id: 1605,
              index: '/ehsHazWasPlan',
              content: '危险废物排污许可',
              showFlag: 1
            }, {
              id: 1606,
              index: '/ehsHazWasHis',
              content: '历史遗留固废管理',
              showFlag: 1
            }, {
              id: 1607,
              index: '/ehsHazWasInd',
              content: '一般工业固废',
              showFlag: 1
            }, {
              id: 1608,
              index: '/ehsLifeJunk',
              content: '生活垃圾',
              showFlag: 1
            }
          ]
        }, {
          id: 1900,
          index: '',
          content: '环保税',
          showFlag: 1,
          children: [
            {
              id: 1901,
              index: '/ehsTaxGas',
              content: '废气环保税',
              showFlag: 1
            }, {
              id: 1902,
              index: '/ehsTaxWater',
              content: '废水环保税',
              showFlag: 1
            }
          ]
        }, {
          id: 1910,
          index: '',
          content: '调查类项目',
          showFlag: 1,
          children: [
            {
              id: 1911,
              index: '/ehsSoilCheck',
              content: '土壤隐患排查',
              showFlag: 1
            }, {
              id: 1912,
              index: '/ehsGroWatCheck',
              content: '地下水调查',
              showFlag: 1
            }, {
              id: 1913,
              index: '/ehsSiteResCheck',
              content: '场地恢复效果调查',
              showFlag: 1
            }, {
              id: 1914,
              index: '/ehsOtherCheck',
              content: '其他调查类项目',
              showFlag: 1
            }
          ]
        }, {
          id: 1920,
          index: '',
          content: '监督检查',
          showFlag: 1,
          children: [
            {
              id: 1921,
              index: '/ehsLocalDep',
              content: '地方环保部门',
              showFlag: 1
            }, {
              id: 1922,
              index: '/ehsSuperCenter',
              content: '监督中心、油田中心',
              showFlag: 1
            }, {
              id: 1923,
              index: '/ehsSelfIns',
              content: '自检自查',
              showFlag: 1
            }
          ]
        }, {
          id: 1924,
          index: '',
          content: '环保交接',
          showFlag: 1,
          children: [
            {
              id: 1925,
              index: '/ehsHandover',
              content: '环保交接',
              showFlag: 1
            }
          ]
        }, {
          id: 1201,
          index: '',
          content: '现场巡查',
          showFlag: 1,
          children: [
            {
              id: 1202,
              index: '/ehsInspection',
              content: '巡查情况',
              showFlag: 1
            // }, {
            //   id: 1213,
            //   index: '/ehsTimeEffList',
            //   content: '时效清单',
            //   showFlag: 1
            // }, {
            //   id: 1214,
            //   index: '/ehsEnvManVer',
            //   content: '环境管理核查',
            //   showFlag: 1
            // }, {
            //   id: 1215,
            //   index: '/ehsSpeCheckReport',
            //   content: '报告专项核对',
            //   showFlag: 1
            // }, {
            //   id: 1216,
            //   index: '/ehsBloPlatform',
            //   content: '排污平台填报核对',
            //   showFlag: 1
            // }, {
            //   id: 1217,
            //   index: '/ehsHazWasteChe',
            //   content: '危废平台填报核对',
            //   showFlag: 1
            }
          ]
        }, {
          id: 1203,
          index: '',
          content: '隐患排查',
          showFlag: 1,
          children: [
            {
              id: 1204,
              index: '/ehsHidProject',
              content: '隐患项目管理',
              showFlag: 1
            // }, {
            //   id: 1205,
            //   index: '/ehsHiddenTrouble',
            //   content: '突发环境事件隐患排查',
            //   showFlag: 1
            }
          ]
        }, {
          id: 1300,
          index: '',
          content: '环保通讯',
          showFlag: 1,
          children: [
            {
              id: 1301,
              index: '/ehsTimedMsg',
              content: '定时提醒',
              showFlag: 1
            }
          ]
        }, {
          id: 83,
          index: '',
          content: '系统管理',
          showFlag: 1,
          children: [
            {
            //   id: 84,
            //   index: '/ehsDepartment',
            //   content: '部门管理',
            //   showFlag: 1
            // }, {
              id: 85,
              index: '/ehsPersonnel',
              content: '人事管理',
              showFlag: 1
            // }, {
            //   id: 86,
            //   index: '/ehsNoticeAdmin',
            //   content: '公告管理',
            //   showFlag: 1
            }
          ]
        }
      ]
    }
  },
  computed: {
  },
  mounted () {
    api.appUserCompany({
    }).then(res => {
      var tempArr = []
      res.data.forEach(item => {
        tempArr.push({
          label: item.cpnName,
          value: item.cpnName
        })
      })
      this.optionsNew = tempArr
      this.showYearDialog = true
    })
  },
  methods: {
    submitUnit () {
      api.appUserUpdate({
        cpnName: this.unitName === 'undefined' ? undefined : this.unitName
      }).then(res => {
        console.log('unitName', res, this.unitName)
        this.showYearDialog = false
      })
    },
    menuTabClicked (id) {
      this.menuTabId = this.menuTabId === id ? 0 : id
    },
    menuSubTabClicked (item) {
      this.menuSubTabId = item.id
      // console.log(item.index) // 路由
      this.iframeSrc = item.index
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
.ehs-menu-page {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  .menu-list {
    width: 240px;
    height: 100%;
    overflow: auto;
    direction: rtl;
    .scrolling-element-inside {
      direction: ltr;
    }
    .m-l-tab {
      width: 100%;
      background: #f4f5f6;
      direction: ltr;
      .tab-clicked {
        background-color: #ccc;
      }
      .tab-hover:hover {
        background-color: #ddd;
      }
      .m-l-tab-label {
        height: 40px;
        padding: 10px 10px;
        border-top: 2px solid #ddd;
        line-height: 40px;
        font-size: 20px;
        font-weight: bold;
      }
      .m-l-SubTab {
        width: 100%;
        background: #f4f5f6;
        .m-l-SubTab-label {
          padding: 10px 10px;
          height: 20px;
          line-height: 20px;
          font-size: 16px;
          font-weight: bold;
          border-top: 1px solid #ddd;
        }
      }
    }
  }
  .main {
    width: calc(100% - 240px);
    height: 100%;
    // background-color: #a32100;
  }
}
</style>
